import { Command } from "@/commands/Command.js"
import { ensureLoggedInForSchemaEdit } from "@/helpers/edit-access"
import {
    cloneConnectionRoute,
    setConnectionRoute,
} from "@/modules/canvas/connection-routing.js"

export class UpdateConnectionRouteCommand extends Command {
    _description = "Update Relationship Route"

    constructor(tab, payload) {
        super(tab, payload)
        this.oldRoute = cloneConnectionRoute(payload.field?.connection_route)
        this.newRoute = cloneConnectionRoute(payload.route)
    }

    async saveData() {
        const schema = ((await import('../stores/schema.store')).useSchemaStore)()
        return schema.saveTable({
            data: this.payload.table,
            saveSilently: true,
        })
    }

    async run() {
        if (!ensureLoggedInForSchemaEdit()) return false
        setConnectionRoute(this.payload.field, this.newRoute)
        const result = await this.saveData()
        super.run()
        return result
    }

    async undo() {
        setConnectionRoute(this.payload.field, this.oldRoute)
        await this.saveData()
        super.undo()
    }
}
